import { Tab } from '../../../../../modals/modifier/ModifierModal';

export default {
  title: 'Ny modifikator',
  tabs: {
    [Tab.General]: 'Generelt',
    [Tab.NutritionInfo]: 'Næringsindhold',
  },
  form: {
    modifier_groups: {
      label: 'Tilhører modifikatorgrupper',
    },
    name: {
      label: 'Navn',
      placeholder: 'Ketchup',
    },
    external_id: {
      label: '{{integration}}-ref.',
      placeholder: 'f.eks. HubRise SKU-reference',
      read_only_hint:
        'Kan kun redigeres, mens en HubRise-integration er forbundet, og menusynkronisering er slået fra.',
    },
    price: {
      label: 'Grundpris',
      placeholder: 'Valgfrit',
    },
    is_available: {
      label: 'På lager',
    },
    is_visible: {
      label: 'Synlig',
      title: 'Synlig i menuen',
      subtitle_on: 'Kunder kan se denne mulighed',
      subtitle_off: 'Skjult for alle kunder',
    },
    is_available_for_pickup: {
      label: 'Tilgængelig til afhentning',
      subtitle_on: 'Kunder kan bestille den til afhentning',
      subtitle_off: 'Skjult i afhentningsmenuen',
    },
    is_available_for_delivery: {
      label: 'Tilgængelig til levering',
      subtitle_on: 'Kunder kan bestille den til levering',
      subtitle_off: 'Skjult i leveringsmenuen',
    },
  },
  availability: {
    title: 'Tilgængelighed',
    helper:
      'Synlighed er hovedkontakten. Slå en kanal fra for at skjule denne mulighed for afhentnings- eller leveringskunder uden at fjerne den fra menuen.',
    status: {
      both: 'Begge kanaler',
      pickup_only: 'Kun afhentning',
      delivery_only: 'Kun levering',
      hidden: 'Skjult',
      no_channels: 'Ingen kanaler',
    },
    warning: {
      no_channels: 'Denne mulighed er synlig, men ikke tilgængelig på nogen kanaler – kunder kan ikke vælge den.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Kun afhentning',
      delivery_only: 'Kun levering',
      no_channels: 'Ingen kanaler',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    changes_got_saved: 'Ændringerne er gemt!',
  },
};
